export const fmtMoney = (n) => {
  if (!Number.isFinite(n) || n < 0) return "$0";
  return `$${Math.round(n).toLocaleString("en-US")}`;
};

export const fmtRate = (n) => {
  if (!Number.isFinite(n) || n < 0) return "0.00%";
  return `${n.toFixed(2)}%`;
};
